import {useEffect, useState} from "react";
import {KatButton, KatModal} from "@amzn/katal-react";
import * as React from "react";
import {EventEmitter} from "events";

interface ConfirmationDialogProps {
    openDialogEvent: string;
    closeDialogEvent: string;
    content: string;
    eventBus: EventEmitter;
}

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const {eventBus} = props;

    useEffect(() => {
        const handleOpenDialog = (isOpen: any) => {
            if (isOpen) {
                setIsOpen(true);
            }
        }

        eventBus.on(props.openDialogEvent, handleOpenDialog);
        return () => {
            eventBus.removeListener(props.openDialogEvent, handleOpenDialog);
        };
    }, []);

    const onConfirmationCancel = () => {
        setIsOpen(false);
    }

    const onConfirmationSubmit = async () => {
        setIsOpen(false);
        eventBus.emit(props.closeDialogEvent, true);
    }

    return (
        <KatModal visible={isOpen} data-testid='kat-modal'>
            <span slot="title">Confirmation</span>
            <p>{props.content}</p>
            <div slot="footer" className="kat-group-horizontal">
                <KatButton variant={"secondary"} label={"Cancel"}
                           onClick={onConfirmationCancel} data-testid='cancel-btn'></KatButton>
                <KatButton label={"Submit"} onClick={onConfirmationSubmit} data-testid='submit-btn'></KatButton>
            </div>
        </KatModal>
    );
};

export default ConfirmationDialog;